import React from 'react';
import { Container } from './styles';
import { AlertIcon } from './AlertIcon';

export const ErrorSearchPlans: React.FC = () => {
  return (
    <Container>
      <div className="content_wrapper">
        <div className='left'>
          <AlertIcon />
        </div>
        <div className='right'>
          <h1>Falha na pesquisa dos planos</h1>
          <p>Algo aconteceu ao carregar os planos!</p>
          <p>tente carregar a página ou aguarde alguns minutos.</p>
        </div>
      </div>
    </Container>
  );
};